/**
 *
 * Asynchronously loads the component for VolunteerTags
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
